<!-- eslint-disable max-len -->
<template>
  <aha-modal
    :title="presentationTooLarge"
    @hide="$emit('hide')"
  >
    <p>
      {{ $i18nPresenter.t('Sorry, this presentation has reached the maximum slide limit. Please consider removing some slides or creating a new presentation.') }}
    </p>

    <template #action>
      <aha-button variant="danger" @click="$emit('hide')">
        OK
      </aha-button>
    </template>
  </aha-modal>
</template>

<script>
export default {
  computed: {
    presentationTooLarge() {
      return this.$i18nPresenter.t('Presentation too large') || ''
    },
  },
}
</script>
